<script>
import SearchForm from '@/components/SearchForm/index.vue'
import AppView from '@/components/AppView.vue'
import SuperTable from '@/components/SuperTable.vue'
import { reactive, ref } from '@vue/composition-api'
import dayjs from 'dayjs'
import { useTable } from '@/hooks/useTable'
import { deleteAnnouncement, getAnnouncementList, getSystemList } from '@/views/announcement/service'
import { useMessage } from '@/hooks/useMessage'
import EditAnnouncement from '@/views/announcement/components/EditAnnouncement.vue'
import PreviewView from '@/views/announcement/components/PreviewView.vue'
import PreviewRelease from '@/views/announcement/components/PreviewRelease.vue'

export default {
  name: 'InformationList',
  components: {
    PreviewRelease,
    PreviewView,
    EditAnnouncement,
    SearchForm,
    AppView,
    SuperTable,
  },
  setup() {
    const { message, confirm } = useMessage()
    const editVisible = ref(false)
    const previewVisible = ref(false)
    const releaseVisible = ref(false)
    const searchForm = reactive({
      sourceSystem: undefined,
    })
    const searchConfig = ref([
      { el: 'VSelect', props: 'targetSystem', label: '接收系统', maxlength: 50, items: [] },
    ])
    const systemList = ref([])

    const tableColumns = ref([
      { props: 'title', label: '标题', minWidth: 250 },
      { props: 'targetSystem', label: '接收系统', minWidth: 250, enum: [] },
      { props: 'updatedAt', label: '发布时间', minWidth: 250, format: value => dayjs(value).format('YYYY-MM-DD') },
      { props: 'sourceUserName', label: '发布人', minWidth: 200 },
      { props: 'operation', label: '操作', width: 180, fixed: 'right' },
    ])
    const { init, search, page, handleSizeChange, handleCurrentChange, tableData, loading } = useTable({
      api: getAnnouncementList,
      initParam: searchForm,
    })

    function getSystemLists() {
      getSystemList().then(({ data }) => {
        if (data.status === 200) {
          const sys = data.data.map(item => ({ text: item.description, value: item.code })).filter(item => item.value !== 7)
          const system = searchConfig.value.find(item => item.props === 'targetSystem')
          if (system) system.items = sys
          const tablesys = tableColumns.value.find(item => item.props === 'targetSystem')
          if (tablesys) tablesys.enum = sys
          systemList.value = sys
        }
        init()
      })
    }
    getSystemLists()
    const rowItem = ref({})
    function fileExport() {
      rowItem.value = {}
      editVisible.value = true
    }

    function openView(row) {
      rowItem.value = row
      previewVisible.value = true
    }

    function edit(row) {
      rowItem.value = row
      editVisible.value = true
    }

    function del(row) {
      confirm('确定删除该公告吗？', '删除', { type: 'error' }).then(() => {
        deleteAnnouncement(row.messageId).then(({ data }) => {
          if (data.status === 200 && data.data) {
            message.success('删除成功')
            search()
          } else {
            message.error(data.message || '删除失败')
          }
        }).catch(error => message.error(error.response?.data?.message || '删除失败'))
      })
    }

    function onSuccess(e) {
      rowItem.value = e
      releaseVisible.value = true
    }

    function goBack() {
      editVisible.value = true
    }

    return {
      searchForm,
      searchConfig,
      tableColumns,
      search,
      page,
      handleSizeChange,
      handleCurrentChange,
      tableData,
      loading,
      fileExport,
      systemList,
      editVisible,
      rowItem,
      openView,
      edit,
      del,
      previewVisible,
      onSuccess,
      releaseVisible,
      goBack,
    }
  },
}
</script>

<template>
  <app-view>
    <template #header>
      <SearchForm :columns="searchConfig" :value="searchForm" :search="search" />
    </template>

    <template #main-header>
      <v-btn color="primary" @click="fileExport">
        新增公告
      </v-btn>
    </template>

    <SuperTable
      ref="tableRef"
      :columns="tableColumns"
      :data="tableData"
      :loading="loading"
    >
      <template #operation="{ row }">
        <span class="app-link operation-link" @click="edit(row)">编辑</span>
        <span class="app-link operation-link" @click="del(row)">删除</span>
        <span class="app-link" @click="openView(row)">详情</span>
      </template>
    </SuperTable>

    <template #footer>
      <vl-pagination
        :page-size="page.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :page-index="page.pageIndex"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>

    <edit-announcement
      v-if="editVisible"
      :system-list="systemList"
      :row-item="rowItem"
      @close="editVisible = false"
      @onSuccess="onSuccess"
    />

    <PreviewView
      v-if="previewVisible"
      :row-item="rowItem"
      @close="previewVisible = false"
    />
    <preview-release
      v-if="releaseVisible"
      :row-item="rowItem"
      @close="releaseVisible = false"
      @onSuccess="search"
      @goBack="goBack"
    />
  </app-view>
</template>

<style scoped lang="scss">
.operation-link {
  margin-right: 16px;
}

::v-deep .v-input {
   .v-input__control {
    .v-input__slot {
      height: 32px;
      margin: 0;

      .v-input__append-inner {
        margin-top: 0 !important;
        height: 100%;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .v-text-field__details {
      transform: translateY(5px);
      margin-bottom: 0;
      min-height: 0;
      .v-messages {
        min-height: min-content;
      }
    }
  }
}
</style>
